import { useSearch } from "@tanstack/react-router"

import { Alert } from "@productlane/ui"

import { MetaInfo } from "@/components/meta-info"
import { api } from "@/lib/api"
import { HubspotContent } from "./content"

export function HubspotFeedbackScreen() {
	const search = useSearch({ strict: false })
	const token = search.token ?? null
	const domain = search.domain ?? null
	const email = search.email ?? null
	const objectId = search.objectId ?? null
	const objectType = search.objectType ?? null
	const userEmail = search.userEmail ?? null

	const dataQuery = api.hubspot.getData.useQuery({
		token,
		objectId,
		objectType,
	})

	return (
		<div className="flex flex-col p-10">
			<MetaInfo title="Hubspot Feedback" />
			<h1 className="mb-4 text-xl font-bold">Push to Productlane</h1>
			{!domain && !email && (
				<Alert header="Required fields missing" variant="info" className="mb-4">
					Please make sure the domain (for companies) or the email (for
					contacts) is specified. You can still move conversations to
					Productlane but we are not able to map it to the correct
					contact/company.
				</Alert>
			)}

			{!dataQuery.data || dataQuery.isLoading ? (
				<div>Loading...</div>
			) : (
				<HubspotContent
					notes={dataQuery.data.notes}
					emails={dataQuery.data.emails}
					calls={dataQuery.data.calls}
					meetings={dataQuery.data.meetings}
					userEmail={userEmail}
				/>
			)}
		</div>
	)
}
